const DetailsSidebarCardAccountsSkeleton = () => {
    return (

        <div className="flex flex-col gap-4">
        {/* Account Ownership Section */}
        <div className="flex flex-col gap-4 border border-[#64748B] rounded-lg p-4 bg-white">
            <div className="h-7 w-48 bg-gray-200 rounded animate-pulse"></div>
            <div className="flex flex-col gap-2">
            <div className="py-2 flex justify-between items-center">
                <div className="flex flex-col gap-2">
                <div className="h-5 w-24 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 w-64 bg-gray-200 rounded animate-pulse"></div>
                </div>
                <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="py-2 flex justify-between items-center">
                <div className="flex flex-col gap-2">
                <div className="h-5 w-20 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
                </div>
            </div>
            <div className="py-2 flex justify-between items-center">
                <div className="flex flex-col gap-2">
                <div className="h-5 w-40 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                </div>
            </div>
            <div className="py-2 flex justify-between items-center">
                <div className="flex flex-col gap-2">
                <div className="h-5 w-44 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-6 w-6 bg-gray-200 rounded animate-pulse"></div>
                </div>
            </div>
            </div>
        </div>

        {/* PIC Details Section */}
        <div className="flex flex-col gap-4 border border-[#64748B] rounded-lg p-4 bg-white">
            <div className="h-7 w-32 bg-gray-200 rounded animate-pulse"></div>
            <div className="flex flex-col gap-2">
            <div className="py-2 flex justify-between items-center">
                <div className="flex flex-col gap-2">
                <div className="h-5 w-16 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
                </div>
                <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="py-2 flex justify-between items-center">
                <div className="flex flex-col gap-2">
                <div className="h-5 w-36 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
                </div>
                <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="py-2 flex justify-between items-center">
                <div className="flex flex-col gap-2">
                <div className="h-5 w-32 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 w-48 bg-gray-200 rounded animate-pulse"></div>
                </div>
                <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
            </div>
            </div>
        </div>

        {/* Upcoming Reminder Section */}
        <div className="flex flex-col gap-4 border border-[#64748B] rounded-lg p-4 bg-white">
            <div className="flex flex-row justify-between items-center">
            <div className="h-7 w-44 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-10 w-32 bg-gray-200 rounded-full animate-pulse"></div>
            </div>
            <div className="p-2 flex flex-col gap-2 rounded-lg bg-[#F2F4F7] border-[#F2F4F7]">
            <div className="h-5 w-3/4 bg-gray-300 rounded animate-pulse"></div>
            <div className="h-4 w-full bg-gray-300 rounded animate-pulse"></div>
            <div className="h-4 w-5/6 bg-gray-300 rounded animate-pulse"></div>
            </div>
        </div>
        </div>
    )
}

export {DetailsSidebarCardAccountsSkeleton}